export function parallax() {
    const $window = $(window);
    const $parallax = $(".has-parallax");

    $window.on("load scroll", function () {
        let scrollTop = $window.scrollTop();
        $parallax.each(function () {
            let $this = $(this);
            let itemTop = $this.offset().top;
            let speed = ($this.data("speed") || 2);

            if ($this.hasClass("bg")) {
                itemTop = $this.offset().top - $window.height();
            }

            $this.css({'transform': 'translateY(' + (scrollTop - itemTop) / speed + 'px' + ')'});
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/parallax.js